import {
   PatientDataAccessAuthorizer,
   PatientDataAccessAuthorizerQuery,
} from '@dreryk/egabinet-patient-access-frontend-api';
import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet, useCqrsSearch } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

type PatientDataAccessRequestStepLoaderChildrenProps = {
   authorizers: PatientDataAccessAuthorizer[];
   patient: PatientSimple;
   refetch: PromiseVoidFunction;
};
type PatientDataAccessRequestStepLoaderProps = {
   readonly patientId: number;
   readonly children: (renderProps: PatientDataAccessRequestStepLoaderChildrenProps) => JSX.Element;
};

export const PatientDataAccessRequestStepLoader = (props: PatientDataAccessRequestStepLoaderProps): JSX.Element => {
   const {
      data: authorizers,
      loading: patientAuthorizersLoading,
      error: patientAuthorizersFault,
      refetch: refetchPatientAuthorizers,
   } = useCqrsSearch<PatientDataAccessAuthorizer>(() => {
      const patientDataAccessAuthorizerQuery = new PatientDataAccessAuthorizerQuery();
      patientDataAccessAuthorizerQuery.patientId = props.patientId;
      return patientDataAccessAuthorizerQuery;
   });

   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<PatientSimple>(() => {
      const query = new PatientSimpleQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (patientAuthorizersLoading || patientLoading) {
      return <LoaderSpinner />;
   }

   if (patientAuthorizersFault || patientError || !authorizers || !patient) {
      return (
         <Message
            testId={'authorizersFetchError'}
            type={MessageType.NEGATIVE}
            label={prescriptionsHistoryDownloadTranslationKeys.authorizersFetchFailed}
            displayIndicator
         />
      );
   }

   return props.children({ authorizers: authorizers, patient: patient, refetch: refetchPatientAuthorizers });
};
